import React, { useEffect, useState } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ColumnHeading from '../../MyExperiment/components/columnHeading'
import { HiOutlineAdjustmentsVertical } from 'react-icons/hi2'
import Icon from '../../../components/icons'
import { URLS } from '../../../_config'
import TemplateCard from './TemplateCard'
import Text from '../../../elements/Typo/Text'
import DomainCard from './DomainCard'
import AOS from 'aos'

import { usePreExistingTemplateApi } from '../../../store/api/hooks/preExistingTemplateApiHook'
import moment from 'moment'
import { useFpLoader } from '../../../store/api/hooks/fpLoaderHook'
import NoResultFound from './NoResultFound'
import Dropdown from '../../../elements/Form/dropdown'
import { Controller, useForm } from 'react-hook-form'
import Button from '../../../elements/button'
import { useCommonApi } from '../../../store/api/hooks/commonApiHook'
import { ErrorResponse } from '../../../store/api/apiTypes'
import { BusinessFunctionDataType, CountryDataType } from '../../../_config/types'
import toast from 'react-hot-toast'
import { startTiming, stopTiming } from '../../../utils/analytics/rumTracking'
import { trackEvent } from '../../../_common/functions'

interface PreExistingTemplateListProps {
    templates: any[]
}

const PreExistingTemplatesDetails: React.FC<PreExistingTemplateListProps> = ({ templates }) => {
    const { t } = useTranslation()
    const params: any = useParams()
    const preExistingTemplateDetails = usePreExistingTemplateApi()
    const { showLoader, hideLoader } = useFpLoader()
    const navigate: any = useNavigate()
    const [deyailsTemplates, setDeyailsTemplates] = React.useState<any[]>([])
    const conmmonApi: any = useCommonApi()
    const [countries, setcountries] = useState<any[]>([])
    const [kpiInterests, setKpiInterests] = useState<any[]>([])
    const [useCases, setUseCases] = useState<any[]>([])
    const [filttersOpen, setFilttersOpen] = useState<boolean>(false)
    const {
        control,
        handleSubmit,
        getValues,

        formState: { errors },
    } = useForm<any>({
        defaultValues: {},
    })
    const getTemplateDetails = () => {
        const payload: any = {
            business_function_literals: params.templateid,
        }
        const filters: any = getValues()
        if (filters?.country) {
            payload.country_literals = filters?.country?.value
        }
        if (filters?.use_case) {
            payload.use_case_literals = filters?.use_case?.value
        }
        if (filters?.kpi) {
            payload.kpi_literals = filters?.kpi?.value
        }
        showLoader()
        setDeyailsTemplates([])
        startTiming('template_detail')
        preExistingTemplateDetails.getTemplate(
            payload,
            (response: any) => {
                hideLoader()
                stopTiming('template_detail', { domain_id: params.templateid ?? '', result_count: response?.data?.result?.length })
                const resultCount = response?.data?.result?.length ?? 0
                trackEvent('template_detail_results_loaded', { domain_id: params.templateid ?? '', result_count: resultCount })
                if (resultCount === 0) {
                    trackEvent('template_no_result_shown', { domain_id: params.templateid, source: 'detail' })
                }
                setDeyailsTemplates(
                    response.data.result?.map((template: any) => {
                        const updatedKpi = {
                            ...template.kpi,
                            literral_value: template.kpi?.name || t('Not Applicable'),
                        }
                        const { hypothesis, ...restTemplate } = template
                        const { problem_statement, ...restTemplateWithoutProblemStatement } = restTemplate
                        return {
                            ...restTemplateWithoutProblemStatement,
                            hypothesisPlaceholder: hypothesis || '',
                            problem_statementPlaceholder: problem_statement || '',

                            id: template.template_literal,
                            experiment_name: template?.country?.title + '_' + template?.business_function?.title + '_',
                            name: template.title,
                            lastUpdated: template.updated_at ? moment(template.updated_at).format('MM DD YYYY') : '',
                            owner: t('DS Team'),
                            kpi: updatedKpi,
                            experiment_metadatas: {
                                ...template.experiment_metadatas,
                                metrices: [updatedKpi, ...(template.experiment_metadatas?.metrices || [])],
                            },

                            topFields: [
                                {
                                    label: t('Hypothesis'),
                                    value: template.hypothesis,
                                },
                                {
                                    label: t('KPI'),
                                    value: template.kpi?.name || t('Not Applicable'),
                                },
                                {
                                    label: t('MDE and Confidence'),
                                    value: `${template.mde}% & ${template.confidence}%`,
                                },
                                {
                                    label: t('Problem Statement'),
                                    value: template.problem_statement,
                                },
                            ],

                            bottomFields: [
                                {
                                    label: t('Country'),
                                    value: template?.country?.title || t('Not Applicable'),
                                },
                                {
                                    label: t('Experiment type'),
                                    value: template?.experiment_type?.title || t('Not Applicable'),
                                },
                                {
                                    label: t('Business Domain'),
                                    value: template?.business_function?.title || t('Not Applicable'),
                                },
                                {
                                    label: t('Use Case'),
                                    value: template?.use_case?.title || t('Not Applicable'),
                                },
                            ],
                        }
                    }),
                )
            },
            (error: any) => {
                hideLoader()
                trackEvent('template_detail_results_failed', { domain_id: params.templateid ?? '', error_message: error?.message })
                console.error('Error fetching template details:', error)
            },
        )
    }
    const getCountries = () => {
        conmmonApi.getCommonDropdown(
            {
                payload: 'countries',
                sort_by: '-country_code',
                page: 1,
                per_page: 1000,
                alldata: true,
            },
            (data: any) => {
                setcountries(
                    data.data.countries
                        ?.map((country: any) => {
                            country.label = country.title
                            country.value = country.country_literal
                            return country
                        })
                        .sort((a: any, b: any) => a.label.localeCompare(b.label)),
                )
            },
            (error: ErrorResponse<CountryDataType[]>) => {
                toast.error(error.message)
            },
        )
    }

    const getKpiTypes = () => {
        conmmonApi.getKpiTypes(
            { sort_by: '-created_at', page: 1, per_page: 1000, alldata: true },
            (data: any) => {
                // const interests = JSON.parse(JSON.stringify(data.data.result))?.map((kpi: any) => {
                const interests = structuredClone(data.data.result)
                    ?.map((kpi: any) => {
                        kpi.label = kpi.name
                        kpi.value = kpi.kpi_literal
                        if (kpi.name === 'Total Distribution' || kpi.name === 'Incremental Conversion' || kpi.name === 'Conversion') {
                            kpi.mode = 'single'
                        }
                        return kpi
                    })
                    .sort((a: any, b: any) => a.label.localeCompare(b.label)) // Sort alphabetically by name

                setKpiInterests(interests)
            },
            (error: ErrorResponse<BusinessFunctionDataType>) => {
                toast.error(error.message)
            },
        )
    }
    const getUseCases = () => {
        conmmonApi.getCommonDropdown(
            { sort_by: '-created_at', payload: 'use_cases', page: 1, per_page: 1000, alldata: true },
            (data: any) => {
                setUseCases(
                    data.data.use_cases
                        ?.map((usecase: any) => {
                            usecase.label = usecase.title
                            usecase.value = usecase.use_case_literal
                            return usecase
                        })
                        .sort((a: any, b: any) => a.label.localeCompare(b.label)),
                )
            },
            (error: ErrorResponse<BusinessFunctionDataType>) => {
                toast.error(error.message)
            },
        )
    }

    const handleBackClick = () => {
        trackEvent('template_no_result_back_clicked', { source: 'detail' })
        navigate(URLS.PREEXISTING_TEMPLATE_LIST())
    }
    useEffect(() => {
        AOS.init({
            once: false, // Animation occurs every time you scroll to the element
        })
        AOS.refresh()
    }, [])
    useEffect(() => {
        trackEvent('template_detail_page_viewed', { domain_id: params.templateid })
        getTemplateDetails()
        getCountries()
        getKpiTypes()
        getUseCases()
    }, [params.templateid])

    const selectedTemplate = templates.find((template) => template.id == params?.templateid)
    const onSubmit = (data: any) => {
        const filters = getValues()
        trackEvent('template_filters_applied', {
            country: filters?.country?.value ?? null,
            use_case: filters?.use_case?.value ?? null,
            kpi: filters?.kpi?.value ?? null,
            domain_id: params.templateid,
        })
        getTemplateDetails()
    }
    const toggleSearch = () => {
        trackEvent('template_filter_panel_toggled', { open: !filttersOpen, domain_id: params.templateid })
        setFilttersOpen(!filttersOpen)
    }

    return (
        <div className="py-[0.667rem] bg-white">
            <div className="mx-[0.667rem] flex flex-col gap-[0.667rem]">
                <div className="py-4 flex flex-col">
                    <div className="flex-grow flex items-center justify-center">
                        <div className=" bg-white rounded-[0.833rem] py-[1.5rem] px-[1.25rem]  shadow-1 w-[62.208rem]">
                            <div className="flex items-center justify-between -ml-[0.5rem]">
                                <ColumnHeading>{t('Pre Existing Template')}</ColumnHeading>
                                <div>
                                    <div className="flex items-center ">
                                        <Link
                                            to={URLS.PREEXISTING_TEMPLATE_LIST()}
                                            onClick={() => trackEvent('template_back_to_list_clicked', { domain_id: params.templateid })}
                                            className="flex items-center gap-1 bg-black rounded-md text-white py-1 px-2 text-[0.541rem] leading-none"
                                        >
                                            <Icon name="arrow-left" size={0.833} className="text-primary" /> <span className="text-[0.581rem]">{t('Back to List')}</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-3 py-2">
                                <div className="px-2" data-aos="zoom-in" data-aos-delay="200">
                                    <div className="py-[1.25rem] pt-[1.3rem]">
                                        <Text className="font-semibold text-[0.8rem] leading-[1.313rem] ">{t('Business Domain')}</Text>
                                    </div>

                                    {templates.map((template) => (
                                        <div key={template.id} className="py-2">
                                            <DomainCard key={template.id} variant={template.id == params?.templateid ? 'black' : 'yellow'} label={template.name} templateid={template.id} icon={template.iconUrl} />
                                        </div>
                                    ))}
                                </div>
                                <div className="col-span-2" data-aos="zoom-in" data-aos-delay="300">
                                    <div className="py-[1.25rem]">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="font-['Poppins'] text-[0.8rem] leading-[1.313rem] text-black">
                                                    <span className="font-semibold">
                                                        {selectedTemplate?.title} {t('Domain')}{' '}
                                                    </span>
                                                    <span className="font-normal">{t('Templates')}</span>
                                                </p>
                                            </div>
                                            <button type="button" onClick={() => toggleSearch()} className="bg-[#f5e003] hover:bg-[#e5d003] active:scale-95 transition-all w-[38px] h-[38px] rounded-[10px] flex items-center justify-center">
                                                <HiOutlineAdjustmentsVertical className="w-[19.5px] h-[18px] text-black" />
                                            </button>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit(onSubmit)} className="">
                                        <div className={`${filttersOpen ? 'h-[4rem] p-2 mb-3' : 'h-0 overflow-hidden'} grid grid-cols-7 gap-1 justify-center items-center rounded-sm bg-[#f5f5f5] p-0 mb-0  transition-all duration-300`}>
                                            <div className="col-span-2">
                                                <Controller
                                                    name="country"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) => (
                                                        <Dropdown
                                                            label={t('Country / zone')}
                                                            isClearable={true}
                                                            placeholder={t('Select Country / zone')}
                                                            value={value}
                                                            onChange={(e: any) => {
                                                                trackEvent('template_filter_country_changed', { country_literal: e?.value ?? null, country_label: e?.label ?? null })
                                                                onChange(e)
                                                            }}
                                                            options={countries}
                                                            error={errors.country?.message as any}
                                                            information={t('Please Select Country / zone from Below options')}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-span-2">
                                                <Controller
                                                    name="use_case"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) => (
                                                        <Dropdown
                                                            label={t('Use Case')}
                                                            placeholder={t('Select Use Case')}
                                                            isClearable={true}
                                                            value={value}
                                                            onChange={(e: any) => {
                                                                trackEvent('template_filter_use_case_changed', { use_case_literal: e?.value ?? null, use_case_label: e?.label ?? null })
                                                                onChange(e)
                                                            }}
                                                            options={useCases}
                                                            error={errors.use_case?.message as any}
                                                            information={t('Please Select Use Case from Below options')}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-span-2">
                                                <Controller
                                                    name="kpi"
                                                    control={control}
                                                    render={({ field: { onChange, value } }) => (
                                                        <Dropdown
                                                            isClearable={true}
                                                            label={t('KPI')}
                                                            placeholder={t('Select KPI')}
                                                            value={value}
                                                            onChange={(e: any) => {
                                                                trackEvent('template_filter_kpi_changed', { kpi_literal: e?.value ?? null, kpi_label: e?.label ?? null })
                                                                onChange(e)
                                                            }}
                                                            options={kpiInterests}
                                                            error={errors.kpi?.message as any}
                                                            information={t('Please Select KPI from Below options')}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-span-1 mt-4">
                                                <Button type="submit" theme="secondary" size="xxs" className="h-[1.7rem] items-center">
                                                    <Icon name="tickMark" size={0.75} />
                                                    {t('Apply')}
                                                </Button>
                                            </div>
                                        </div>
                                    </form>
                                    {deyailsTemplates.map((template) => (
                                        <div key={template.id} className="flex flex-col gap-[20px] pb-2">
                                            <TemplateCard
                                                template={template}
                                                key={template.id}
                                                name={template.name}
                                                lastUpdated={template.lastUpdated}
                                                owner={template.owner}
                                                topFields={template.topFields}
                                                bottomFields={template.bottomFields}
                                                source="detail"
                                                domainId={params.templateid}
                                            />
                                        </div>
                                    ))}
                                    {deyailsTemplates.length === 0 && (
                                        <div className="min-h-screen flex items-center justify-center bg-white p-8">
                                            <NoResultFound onBackClick={handleBackClick} title={t('No Result Found')} description={t('Please search with proper keyword to view more template')} buttonText={t('Back to List')} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PreExistingTemplatesDetails
